import { tryRouteToCloud } from "../cloudRouting/tryRouteToCloud.js";
import { ExtensionStatus } from "../zustand/extensionInfos.js";
import { isCloudSessionMode } from "../zustand/sessionMode.js";
import { ChromeMessage } from "./extension/types.js";
import { isNavigatorValidAndWithAnExtension } from "./validateNavigator.js";

const sendMessage = async <T>(params: {
    extensionId: string;
    extensionStatus?: ExtensionStatus;
    message: ChromeMessage;
    retryDelay?: number;
    maxTries?: number;
    forceExtensionUse?: boolean;
}): Promise<T> => {
    const { extensionId, message, forceExtensionUse } = params;

    if ((forceExtensionUse || !isCloudSessionMode()) && isNavigatorValidAndWithAnExtension()) {
        return new Promise<T>((resolve) => {
            return window.chrome.runtime.sendMessage(extensionId, message, resolve);
        }).catch((error) => {
            console.error("Error sending message to extension:", error);
            return undefined as unknown as T;
        });
    }

    const cloudResult = await tryRouteToCloud(message);
    if (cloudResult.routed) return cloudResult.result as T;

    return Promise.resolve(undefined as unknown as T);
};

export default sendMessage;
